import { render, staticRenderFns } from "./RouteToAction.vue?vue&type=template&id=21710e3e&scoped=true&"
import script from "./RouteToAction.vue?vue&type=script&lang=js&"
export * from "./RouteToAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21710e3e",
  null
  
)

export default component.exports